import { type ComponentStyleConfig } from '@chakra-ui/react'

import { pxToEm } from '../../utils/pxToEm'
import { pxToRem } from '../../utils/pxToRem'

export const Table: ComponentStyleConfig = {
  variants: {
    wysiwyg: {
      th: {
        fontSize: pxToEm(20),
        borderBottom: '4px groove',
        fontWeight: '350',
        textTransform: 'none',
        px: pxToRem(16),
        py: pxToRem(16),
        p: {
          fontWeight: 'inherit',
          mb: 0,
          whiteSpace: 'nowrap',
          minWidth: pxToRem(100),
        },
      },
      td: {
        borderBottom: '1px solid',
        borderColor: 'primary.grey.80',
        px: pxToRem(16),
        py: pxToRem(16),
        p: {
          fontSize: pxToEm(16),
          mb: 0,
          wordBreak: 'normal',
          minWidth: pxToRem(100),
        },
      },
      tr: {
        '&:last-of-type': {
          td: {
            borderColor: 'transparent',
          },
        },
      },
    },

    documents: {
      thead: {
        th: {
          backgroundColor: 'primary.darkGreen.100',
          color: 'primary.white.100',
          fontSize: {
            base: pxToEm(18),
            lg: pxToEm(20),
          },
          fontWeight: '350',
          textTransform: 'none',
          py: {
            base: '20px',
            lg: '40px',
          },
          px: '30px',
          minWidth: '200px',

          '&:first-of-type': {
            borderTopLeftRadius: '10px',
          },

          '&:last-child': {
            borderTopRightRadius: '10px',
          },
          '&.whiteCell': {
            backgroundColor: 'primary.white.100',
            color: 'primary.darkGreen.100',
          },
        },
      },
      tbody: {
        tr: {
          '&:last-child': {
            td: {
              borderBottomWidth: '1px',

              '&:first-of-type': {
                borderBottomLeftRadius: '2px',
              },

              '&:last-child': {
                borderBottomRightRadius: '2px',
              },
            },
          },
          '&:nth-child(even)': {
            backgroundColor: 'primary.grey.60',
          },
        },
        th: {
          '&:first-of-type': {
            borderTopLeftRadius: '10px',
          },

          '&:last-child': {
            borderTopRightRadius: '10px',
          },
        },
        td: {
          color: 'primary.teal.100',
          fontSize: pxToRem(14),
          px: '30px',
          borderColor: 'primary.grey.80',
          py: {
            base: '20px',
            lg: '30px',
          },
          p: {
            fontWeight: '300',
            fontSize: 'inherit',
            lineHeight: pxToRem(22.5),
          },

          a: {
            fontWeight: '400',
            textDecoration: 'underline',

            '&:hover': {
              color: 'primary.teal.60',
            },

            '&:focus': {
              color: 'primary.teal.60',
            },
          },

          '&:first-of-type': {
            borderLeftWidth: '1px',
          },

          '&:last-child': {
            borderRightWidth: '1px',
          },
        },
      },
    },
  },
}
